import { z } from "zod";
import type { IntlShape } from "react-intl";

export const passwordSchemaRules = (intl: IntlShape) => ({
	minLength: z.string().min(
		8,
		intl.formatMessage({
			id: "validation.password.minLength",
			defaultMessage: "Password must be at least 8 characters",
		}),
	),
	hasLowercase: z.string().regex(
		/[a-z]/,
		intl.formatMessage({
			id: "validation.password.lowercase",
			defaultMessage: "Password must contain lowercase characters",
		}),
	),
	hasUppercase: z.string().regex(
		/[A-Z]/,
		intl.formatMessage({
			id: "validation.password.uppercase",
			defaultMessage: "Password must contain uppercase characters",
		}),
	),
	hasNumber: z.string().regex(
		/[0-9]/,
		intl.formatMessage({
			id: "validation.password.number",
			defaultMessage: "Password must contain numbers",
		}),
	),
	hasSymbol: z.string().regex(
		/[^a-zA-Z0-9]/,
		intl.formatMessage({
			id: "validation.password.symbol",
			defaultMessage: "Password must contain symbols",
		}),
	),
});

export const getPasswordSchema = (intl: IntlShape) => {
	const rules = passwordSchemaRules(intl);

	return z
		.string()
		.pipe(rules.minLength)
		.pipe(rules.hasLowercase)
		.pipe(rules.hasUppercase)
		.pipe(rules.hasNumber)
		.pipe(rules.hasSymbol);
};
